import { render } from "./CriptoMcp.vue?vue&type=template&id=79aef627&scoped=true"
import script from "./CriptoMcp.vue?vue&type=script&lang=js"
export * from "./CriptoMcp.vue?vue&type=script&lang=js"

import "./CriptoMcp.vue?vue&type=style&index=0&id=79aef627&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79aef627"]])

export default __exports__